import { render, staticRenderFns } from "./SendEmailConfig.vue?vue&type=template&id=77ed83f2&scoped=true"
import script from "./SendEmailConfig.vue?vue&type=script&lang=js"
export * from "./SendEmailConfig.vue?vue&type=script&lang=js"
import style0 from "./SendEmailConfig.vue?vue&type=style&index=0&id=77ed83f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed83f2",
  null
  
)

export default component.exports